module.exports = __webpack_public_path__ + "img/wechat.9446af60.png";